import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DISABLED_MSG, MAGNET_DISABLED_MSG } from 'cards/constants/CardLevelOptions';
import DetailBox from '../DetailBox/DetailBox';
import ToggleList from '../ToggleList/ToggleList';

import './OptionList.less';

const OptionList = ({
  options,
  currentSelection,
  onToggle,
  optionType,
  isMagnet,
  isLinkHidden,
  titleLink,
  titleLinkAction,
}) => {
  const [currentHover, setCurrentHover] = useState(null);

  function updateCurrentHover(newVal) {
    setCurrentHover(newVal);
  }

  function detailSelector(newVal) {
    return options.find(option => {
      return option.value === newVal;
    });
  }

  return (
    <React.Fragment>
      <div className="option-list-wrapper">
        <div className="option-list">
          <DetailBox
            show={!!currentHover}
            details={detailSelector(currentHover)}
            isMagnet={isMagnet}
          />
        </div>
      </div>
      <ToggleList
        currentSelection={currentSelection}
        options={options}
        onHover={updateCurrentHover}
        onToggle={onToggle}
        isMagnet={isMagnet}
        tooltipMessage={isMagnet ? MAGNET_DISABLED_MSG[optionType] : DISABLED_MSG[optionType]}
      />
      {optionType === 'paper-type' ? (
        <div className="option-list-mobile-details">
          <DetailBox
            details={detailSelector(currentSelection.value)}
            isLinkHidden={isLinkHidden}
            titleLink={titleLink}
            titleLinkAction={titleLinkAction}
            show
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};

OptionList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      hide: PropTypes.bool,
      subTitle: PropTypes.string,
      iconEnabled: PropTypes.node,
      iconDisabled: PropTypes.node,
    })
  ),
  currentSelection: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onToggle: PropTypes.func,
  optionType: PropTypes.string,
  isMagnet: PropTypes.bool,
  titleLink: PropTypes.string,
  titleLinkAction: PropTypes.func,
};

OptionList.defaultProps = {
  onToggle: () => {},
};

export default OptionList;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/OptionList/OptionList.jsx